import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setCredentials } from '../redux/action/authSlice';
import toast from 'react-hot-toast';
import { Navbar, Footer } from '../components';
import api from '../utils/api';

const AuthCallback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const processed = useRef(false); // Prevent double-firing in React StrictMode

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const urlParams = new URLSearchParams(window.location.search);
    // 'state' is used by Google OAuth / Socialite for the redirect ref
    const redirectTo = urlParams.get('state') || urlParams.get('ref') || '/';
    const error = urlParams.get('error');

    if (error) {
      const msg = urlParams.get('message') || error;
      toast.error(`Login gagal: ${decodeURIComponent(msg)}`);
      navigate('/login');
      return;
    }

    if (hash && hash.includes('token=')) {
      const rawToken = hash.split('token=')[1]?.split('&')[0];

      if (rawToken) {
        const token = decodeURIComponent(rawToken);

        // Store the token first so api.js can use it in the Authorization header
        localStorage.setItem('auth_token', token);

        // Fetch full user profile from backend
        api.get('/api/auth/me')
          .then((res) => {
            const user = res.data?.user;
            if (!user) throw new Error('No user data returned');

            dispatch(setCredentials({ user, token }));
            toast.success('Login berhasil!');

            // All users land on frontend — admin/seller can use Dashboard button in navbar
            const safeRedirect = redirectTo && redirectTo.startsWith('/')
              ? redirectTo
              : '/';
            navigate(safeRedirect, { replace: true });
          })
          .catch((err) => {
            // If /me fails, clear the token and ask user to re-login
            localStorage.removeItem('auth_token');
            console.error('Failed to fetch user after Google login:', err);
            toast.error('Gagal mengambil data pengguna. Silahkan coba lagi.');
            navigate('/login');
          });

      } else {
        toast.error('Autentikasi gagal. Token tidak diterima.');
        navigate('/login');
      }
    } else {
      // No token in hash, redirect to login
      navigate('/login');
    }
  }, [navigate, dispatch]);

  return (
    <>
      <Navbar />
      <div className="min-h-screen flex items-center justify-center bg-zinc-950 text-white">
        <div className="text-center flex flex-col items-center gap-4">
          <div className="w-14 h-14 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin" />
          <h2 className="text-xl font-bold">Mengautentikasi...</h2>
          <p className="text-zinc-400 text-sm">Harap tunggu, kami sedang memverifikasi akun Anda.</p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AuthCallback;
